import { Box, Typography, useMediaQuery } from '@mui/material';
import AgenciesTable from './components/AgenciesTable';

const SurePassAdminPage: React.FC = () => {
  // Match the users page so the table footer sits at the bottom of the
  // screen next to the Help Scout beacon
  const isSmallScreen = useMediaQuery('(max-width:1024px)');

  return (
    <Box
      component={'main'}
      sx={{
        gridArea: 'main',
        height: isSmallScreen ? 'calc(100vh - 80px)' : 'calc(100vh - 48px)',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0
      }}>
      <Typography component='h1' variant='xxl'>SurePass Admin</Typography>
      <Box sx={{ marginTop: 3, flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <AgenciesTable />
      </Box>
    </Box>
  );
};

export default SurePassAdminPage;
